import { Suspense } from 'react';

import { RouterProvider } from 'react-router-dom';

import { QueryProvider } from '@/app/providers/QueryProvider';
import { ThemeProvider } from '@/app/providers/ThemeProvider';
import { appRouter } from '@/app/routes/router';

export function App(): React.JSX.Element {
  return (
    <ThemeProvider>
      <QueryProvider>
        <Suspense
          fallback={
            <div className="flex min-h-screen items-center justify-center">
              <span className="loading loading-ring loading-lg text-primary" />
            </div>
          }
        >
          <RouterProvider router={appRouter} />
        </Suspense>
      </QueryProvider>
    </ThemeProvider>
  );
}
